import { createApiRef, IdentityApi } from '@backstage/core-plugin-api';
import { NotificationServiceApi, NotificationServiceCommon, RestClientApi } from '@runway/devkit-common';

export const NotificationServiceApiRef = createApiRef<NotificationServiceApi>({
  id: 'plugin.devkit.notification-service.service',
});

export class NotificationService extends NotificationServiceCommon {
  constructor(
    backendUrl: string,
    restClient: RestClientApi,
    private identityApi: IdentityApi,
  ) {
    super(backendUrl, '', restClient);
  }

  getToken = async () => (await this.identityApi.getCredentials()).token || '';
}
